import { render, staticRenderFns } from "./ActiveTimeByMatchDay.vue?vue&type=template&id=6edb5d4a&scoped=true&"
import script from "./ActiveTimeByMatchDay.vue?vue&type=script&lang=js&"
export * from "./ActiveTimeByMatchDay.vue?vue&type=script&lang=js&"
import style0 from "./ActiveTimeByMatchDay.vue?vue&type=style&index=0&id=6edb5d4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edb5d4a",
  null
  
)

export default component.exports